import Main from './Main.vue'
import AddRetirada from './components/addRetirada'

export default [{
  path: 'retirada',
  name: 'retirada',
  component: Main,
  children: [
    {path: 'adicionar/:id', component: AddRetirada, name: 'retirada.adicionar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/retirada/routes.js